<div class="innerpage-fullwithbanner placeoffer-modify" *ngIf="!IsFromPropertyView && !showPortfolio">
  <h2 class="bighead">Place Offers</h2>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="fromPage == 'PropertyView'"><a href="javascript:void(0);" (click)="onViewProperty();">Property Detail<span>|</span></a></li>
    <li *ngIf="fromPage == 'MyOffers'"><a href="javascript:void(0);" (click)="onMyOffers();">My Offers<span>|</span></a></li>
    <li>Place Offer</li>
  </ul>
</div>

<div class="registration1031  margin-bottom-30 clearfix col-md-12" [hidden]="!showPortfolio" id="divPlaceOfferChild" [ngClass]="{'show':wizard == 0,'hide':wizard != 0}">
  <div class="border-div row placeoffersection container container-lg" [ngClass]="{'show':wizard == 0,'hide':wizard != 0}" style="background:#fff;">
    <h2 class="mainhead"><span class="text">Placing offer made easier</span></h2>
    <div class="text-center place_button_grp margin-bottom-40">
      <div class="btn-group" role="group">
        <button class="btn btn-lg btn-border" (click)="showWizard(1);"><i aria-hidden="true" class="icofont icofont-upload-alt icon"></i> Upload LOI</button>
        <button class="btn btn-lg btn-green" (click)="showWizard(11);"><img style="margin-right:4px;" src="assets/img/edit-document.svg" /> Generate LOI</button>
      </div>
    </div>

    <!--<div class="threeblocks">
      <div class="row">

        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="round bluebg">
            <span class="icofont icofont-share icon"><i></i></span>
          </div>
          <h3>Share with Others</h3>

        </div>

        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="round bdarkluebg">
            <span class="icon-download icon"><i></i></span>
          </div>
          <h3>Download LOI</h3>

        </div>

        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="round redbg">
            <span class="icofont icofont-refresh icon"><i></i></span>
          </div>
          <h3>Modify Offer</h3>


        </div>

      </div>
    </div>-->

  </div>
</div>
<div class="row form-radio" style="width: 550px; float: right; padding-top: 20px" *ngIf="isFromQuickEdit" [ngClass]="{'show': (wizard == 1 || wizard == 11),'hide': (wizard != 1 || wizard != 11)}">
  <div class="col-md-6 col-sm-6 col-xs-6">
    <input name="radio" type="radio" (change)="showWizard(1);" value="uploadmyownloi" [(ngModel)]="offerInputModel.uploadType">
    <i class="helper"></i>Upload my own LOI
  </div>
  <div class="col-md-6 col-sm-6 col-xs-6">
    <label class="radio radio-inline margin-bottom-10">
      <!--<input name="radio" type="radio" (change)="onRentEscalationChange(false)">-->
      <input name="radio" type="radio" value="generateloi" [(ngModel)]="offerInputModel.uploadType" (change)="showWizard(11);" />
      <i class="helper"></i>Generate LOI for me
    </label>
  </div>
</div>
<div class="clearfix"></div>
<div class="placeoffersection container container-lg section-margin">
  <div class="registration1031 border-div" style="background:#fff;">
    <div class="row" *ngIf="!isFromQuickEdit" [ngClass]="{'show':((wizard == 1) || wizard == 11),'hide':(wizard != 1 && wizard != 11)}">
      <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12" [ngClass]="{'nocontactsin-placeoffer': propertyDetailForOffer.PrimaryContactName == null || propType !== 601 }">
        <div class="bg-boxes2 border-div propertydetailstop" style="background:#fff !important;" *ngIf="!showPortfolio">
          <div class="left">
            <div class="thumbs2" [ngStyle]="{'background-image': 'url(' + propertyDetailForOffer.FilePath + ')'}"></div>
            <div class="detailsdiv">
              <h4 popover="{{propertyDetailForOffer.PropertyName}} {{haveaccesstoviewlocation?propertyDetailForOffer.City +', ':' Confidential'}}, {{haveaccesstoviewlocation?propertyDetailForOffer.State:''}}" placement="top" container="body" triggers="mouseenter:mouseleave">{{propertyDetailForOffer.PropertyName}}</h4>
              <p *ngIf="propertyDetailForOffer.City || propertyDetailForOffer.State">{{haveaccesstoviewlocation?propertyDetailForOffer.City +', ':' Confidential'}}, {{haveaccesstoviewlocation?propertyDetailForOffer.State:''}}</p>
              <h5><span tooltip="{{propertyDetailForOffer.PropertyType}}">{{_commonService.GetPropertyTypeWithCount(propertyDetailForOffer.PropertyType)}}</span></h5>

            </div>
            <div class="clearfix"></div>
          </div>
          <div class="right">
            <ul>
              <li>
                <h5>Asking Price </h5>
                <h6 *ngIf="propertyDetailForOffer.Unpriced">Unpriced</h6>
                <h6 *ngIf="!propertyDetailForOffer.Unpriced">{{propertyDetailForOffer.Price!=0?('$ '+ (propertyDetailForOffer.Price|number)):'-'}}</h6>
              </li>
              <li>
                <h5>NOI</h5>
                <h6>{{propertyDetailForOffer.NOI!=null && propertyDetailForOffer.NOI!=0 ?('$ '+ (propertyDetailForOffer.NOI|number)):'-'}}</h6>
              </li>
              <li>
                <h5>CAP Rate</h5>
                <h6>{{propertyDetailForOffer.CapRate!=null && propertyDetailForOffer.CapRate!=0 ?((propertyDetailForOffer.CapRate)+'%'):'-'}}</h6>
              </li>
            </ul>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 property-contact" *ngIf="propertyDetailForOffer.PrimaryContactName !== null && propType == 601 && !showPortfolio">
        <div class="bg-boxes2 border-div">
          <ul class="contacts">
            <li class="clearfix">
              <div class="imgblock" [ngStyle]="{'background-image': 'url(' + propertyDetailForOffer.PrimaryContactImagePath + ')'}">
              </div>
              <div class="data">
                <h3>{{propertyDetailForOffer.PrimaryContactName!=null?((propertyDetailForOffer.PrimaryContactName)):'-'}} <span>- {{propertyDetailForOffer.PrimaryContactRole}}</span></h3>
                <p *ngIf="propertyDetailForOffer.PrimaryContactPhone">
                  <i class="icon-phone icon"></i>{{propertyDetailForOffer.PrimaryContactPhone ? (propertyDetailForOffer.PrimaryContactPhone | phone):'-'}}
                </p>
                <p *ngIf="propertyDetailForOffer.PrimaryContactEmail">
                  <i class="icon-message icon"></i>
                  <a href="#">{{propertyDetailForOffer.PrimaryContactEmail ? (propertyDetailForOffer.PrimaryContactEmail):'-'}}</a>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div [ngClass]="{'show':wizard == 11,'hide':wizard != 11}">
      <div class="row" *ngIf="!isNormalPrincipalView && !IsExternalBroker&&showLinkto1031Exchange">
        <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12 inline-checkbox margin-bottom-20">
          <label class="custom-checkbox">
            <input type="checkbox" [disabled]="isEdit || isFromQuickEdit" [(ngModel)]="offerInputModel.Is1031Exchange" (keydown)="onKeydown($event,'tab1')" (change)="onIs1031ExchangeCheckboxChange(offerInputModel.Is1031Exchange)">
            Link to B+E 1031 Exchange  <span style="font:italic;margin-left:10px;color:red"> Note : Exchange once set cannot be modified.</span>
            <i></i>
          </label>
        </div>
        <div *ngIf="(isBrokerView || authService.Admin()||authService.SuperAdmin())" class="col-lg-4 col-md-4 col-sm-6 col-xs-12 inline-checkbox" style="text-align:right !important">
          <button type="button" *ngIf="selectExchange == 'Change Exchange'" class="btn btn-default btn-lg margin-right-10" (click)="ClearExchange()">Clear</button>
          <button *ngIf="offerInputModel.Is1031Exchange && !isEdit && !isFromQuickEdit" class="btn-border btn adduserbtn" (click)="openBrokerModal(templateBrokers,'panlestyle')">{{selectExchange}}</button>
        </div>
      </div>

      <!--<div class="row" *ngIf="!isNormalPrincipalView && !IsExternalBroker && propType == 601 && isBrokerView" [hidden]="true">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12 inline-checkbox margin-bottom-20">
              <label class="custom-checkbox">
                  <input type="checkbox" [disabled]="isEdit" [(ngModel)]="offerInputModel.OfferForExtBroker" (change)="onExternalBrokerPlaceOffer()">
                  Place offer on behalf of Co-Broker
                  <i></i>
              </label>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 inline-checkbox" *ngIf="offerInputModel.OfferForExtBroker && !isEdit" style="text-align:right !important">
              <button type="button" *ngIf="brokerSelectedFromSlider" class="btn btn-default btn-lg margin-bottom-15 margin-right-10 margin-top-20" (click)="clearBrokerSelectedFromSlider();">Clear</button>
              <button class="btn-border btn adduserbtn" (click)="openBrokerModal(templateExtBroker,'panlestyle')">{{selectBroker}}</button>
          </div>
      </div>-->
      <div class="row  margin-bottom-20">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 inline-checkbox" *ngIf="(authService.Broker()|| authService.Admin()||authService.SuperAdmin()) && (((offerInputModel.CoBrokerId == 0 || offerInputModel.CoBrokerId== null)&&(offerInputModel.OfferForExtBroker == false||offerInputModel.OfferForExtBroker==null)) ||(offerInputModel.CoBrokerId > 0 && (offerInputModel.OfferForExtBroker == false||offerInputModel.OfferForExtBroker==null)))">
          <label class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="offerInputModel.IsSendMail">
            Send Notification
            <i></i>
          </label>
        </div>

      </div>

      <div class="row" *ngIf="offerInputModel.Is1031Exchange && !isNormalPrincipalView">

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="exchangeCodes?.length > 0">
          <div class="form-group">
            <label class="form-label">1031 Exchanges</label>
            <label class="select breadcumbarea-select bigselect">
              <div class="information" *ngIf="IsConnectedExchange" tooltip="Connected Exchange" placement="left"><span class="fa fa-info"></span></div>
              <select class="form-control" [(ngModel)]="offerInputModel.Exchange1031Id" (change)="on1031ExchangeChange($event)" (keydown)="onKeydown($event,'tab1')">
                <option *ngFor="let item of exchangeCodes" [(ngValue)]="item.Id">{{item.ExchangeCode}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
      </div>

      <div class="floatinghead clearfix" *ngIf="!offerInputModel.OfferForExtBroker">
        <h2 class="mainhead "><span class="text">Buyer Information</span><!--<i tooltip="Buyer Information" class="fa fa-info-circle infoicon" aria-hidden="true"></i>--></h2>
      </div>
      <div *ngIf="showBuyerInfoForPrincipal && !offerInputModel.OfferForExtBroker">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">First Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event,'tab2')" disabled #firstNameinput="ngModel" required [(ngModel)]="offerInputModel.FirstName" maxlength="100">
              <p class="redtext" *ngIf="(firstNameValid && firstNameinput.invalid && firstNameinput.touched)">First name is required </p>

            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.LastName" (keydown)="onKeydown($event,'tab2')" maxlength="100">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span class="red">*</span></label>
              <input class="form-control" disabled #emailinput="ngModel" (keydown)="onKeydown($event,'tab2')" (change)="validateEmail()" autocomplete="off" maxlength="100" required [(ngModel)]="offerInputModel.Email">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" disabled #phoneNumberinput="ngModel" (keydown)="onKeydown($event,'tab2')" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20">
              <p class="redtext" *ngIf="(phoneValid) && phoneNumberinput.invalid && phoneNumberinput.touched">Phone number is required</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.CompanyName" (keydown)="onKeydown($event,'tab2')" maxlength="200">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Buyer Entity</label>
              <input class="form-control" (keydown)="onKeydown($event,'tab2')" [(ngModel)]="offerInputModel.BuyerEntity" maxlength="200">
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(isBrokerView || authService.Admin()||authService.SuperAdmin()) && !offerInputModel.OfferForExtBroker">
        <div class="row" *ngIf="disableTextBox === 'true'">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="offerInputModel.Exchange1031Id>0">
            <div class="form-group">
              <label class="form-label">Exchange ID</label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.Exchange1031Id">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group autocomplete-design">
              <label class="form-label">
                First Name<span class="star">*</span>
              </label>

              <input class="form-control" #firstNameinput="ngModel" (keydown)="onBuyerInfoKeydown()" [(ngModel)]="offerInputModel.FirstName" required maxlength="100" [disabled]="true">
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" #lastNameinput="ngModel" (keydown)="onBuyerInfoKeydown()" [(ngModel)]="offerInputModel.LastName" required maxlength="100" [disabled]="true">
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span class="red">*</span></label>
              <input class="form-control" #emailinput="ngModel" (keydown)="onBuyerInfoKeydown()" autocomplete="off" maxlength="100" required [disabled]="true" [(ngModel)]="offerInputModel.Email">

            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" #phoneNumberinput="ngModel" (keydown)="onBuyerInfoKeydown()" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' id="txtPhone" maxlength="20" [disabled]="true">

            </div>
          </div>

          <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12" *ngIf="disableTextBox === 'true'">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Company Name</label>
                  <input class="form-control" [(ngModel)]="offerInputModel.CompanyName" [disabled]="true" maxlength="200">
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Buyer Entity</label>
                  <input class="form-control" [(ngModel)]="offerInputModel.BuyerEntity" maxlength="200">
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="row" *ngIf="disableTextBox === 'false' && !IsExternalBroker">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="offerInputModel.Exchange1031Id>0">
            <div class="form-group">
              <label class="form-label">Exchange ID</label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.Exchange1031Id">
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" (change)="checkDuplicateUser()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [disabled]="isEdit" [(ngModel)]="offerInputModel.Email">

              <p class="redtext" *ngIf="((emailValid) || emailinput.invalid && emailinput.touched) && emailvalidation=='' ">Email is required</p>

              <p class="redtext" *ngIf="(emailvalidation!='' && offerInputModel.Email!='' )">{{emailvalidation}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group autocomplete-design">
              <label class="form-label">
                First Name<span class="star">*</span>
              </label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #firstNameinput="ngModel" [(ngModel)]="offerInputModel.FirstName" required maxlength="100" [disabled]="isEdit">
              <p class="redtext" *ngIf="(firstNameValid) || firstNameinput.invalid && firstNameinput.touched">First Name is required</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #lastNameinput="ngModel" [(ngModel)]="offerInputModel.LastName" required maxlength="100" [disabled]="isEdit">
              <p class="redtext" *ngIf="(lastNameValid) || (lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #phoneNumberinput="ngModel" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhone" [disabled]="isEdit">
              <p class="redtext" *ngIf="((phoneValid) || (phoneNumberinput.invalid && phoneNumberinput.touched) )&& phoneValidation =='' ">Phone number is required</p>
              <p class="redtext" *ngIf="(phoneValidation!='' && offerInputModel.Phone !='')">{{phoneValidation}}</p>
            </div>
          </div>
        </div>
        <!--External Broker buyer information-->
        <div class="row" *ngIf="disableTextBox === 'false' && IsExternalBroker && !offerInputModel.OfferForExtBroker">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="offerInputModel.Exchange1031Id>0">
            <div class="form-group">
              <label class="form-label">Exchange ID</label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.Exchange1031Id">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group autocomplete-design">
              <label class="form-label">
                First Name<span class="star">*</span>
              </label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #firstNameinput="ngModel" [(ngModel)]="offerInputModel.FirstName" required maxlength="100" [disabled]="isEdit">
              <p class="redtext" *ngIf="(firstNameValid) || firstNameinput.invalid && firstNameinput.touched">First Name is required</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #lastNameinput="ngModel" [(ngModel)]="offerInputModel.LastName" required maxlength="100" [disabled]="isEdit">
              <p class="redtext" *ngIf="(lastNameValid) || (lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email</label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [disabled]="isEdit" [(ngModel)]="offerInputModel.Email">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone</label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #phoneNumberinput="ngModel" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhone" [disabled]="isEdit">
            </div>
          </div>
        </div>


        <div class="row" *ngIf="disableTextBox === 'false'">
          <!--</div>
          <div class="row">-->
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" [(ngModel)]="offerInputModel.CompanyName" maxlength="200">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Buyer Entity</label>
              <input class="form-control" [(ngModel)]="offerInputModel.BuyerEntity" maxlength="200">
            </div>
          </div>
        </div>
        <div [hidden]="true">
          <h2 class="mainhead "><span class="text">Co-Broker Information</span></h2>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">First Name</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerFirstName">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Last Name</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerLastName">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Email</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerEmail">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Phone</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerPhone" mask='(000) 000-0000'>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Broker view when placing offer on behalf of external broker start-->
      <ng-container *ngTemplateOutlet="BrokerForEB"></ng-container>
      <!--Broker view when placing offer on behalf of external broker end-->
      <h2 class="mainhead "><span class="text">Offer Details</span></h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Asking Price </label>
            <div class="textbox-with-btn-left" *ngIf="!propertyDetailForOffer.Unpriced">
              <input disabled class="form-control" value="{{propertyDetailForOffer.Price|number}}" />
              <span class="leftlabel">$</span>
            </div>
            <div class="textbox-with-btn" *ngIf="propertyDetailForOffer.Unpriced">
              <input disabled class="form-control" value="Unpriced" />
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Offer Price <span class="red">*</span></label>
            <div class="textbox-with-btn-left">
              <input type="text" inputmode="numeric" class="form-control" (keydown)="onKeydown($event,'tab1')" mask="separator.10" thousandSeparator="," maxlength="18" (change)="offerPriceValidation()" required [(ngModel)]="offerInputModel.OfferPrice" #offerpriceinput="ngModel">
              <span class="leftlabel">$</span>
            </div>
            <p class="redtext" *ngIf="(offerPriceValid)||(offerpriceinput.invalid && offerpriceinput.touched)">{{offerPriceValidText}}</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Earnest Money Deposit <span class="red">*</span></label>
            <div class="textbox-with-btn-left">
              <input class="form-control" type="text" inputmode="numeric" mask="separator.10" thousandSeparator="," (keydown)="onKeydown($event,'tab1')" maxlength="18" (change)="earnestMoneyDepositValidation()" #earnestMoneyDepositinput="ngModel" required [(ngModel)]="offerInputModel.EarnestMoneyDeposit">
              <span class="leftlabel">$</span>
            </div>
            <p class="redtext" *ngIf="(earnestMoneyDepositValid) ||(earnestMoneyDepositinput.invalid && earnestMoneyDepositinput.touched)">{{earnestMoneyDepositValidText}}</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Due Diligence Period <span class="red">*</span></label>
            <div class="textbox-with-btn">
              <input class="form-control" mask="999" #dueDiligencePeriodinput="ngModel" (keydown)="onKeydown($event,'tab1')" required (change)="dueDiligencePeriodValidation()" [(ngModel)]="offerInputModel.DueDiligencePeriod">
              <span class="rightlabel">Days</span>
            </div>
            <p class="redtext" *ngIf="(dueDiligencePeriodValid) ||(dueDiligencePeriodinput.invalid && dueDiligencePeriodinput.touched)">{{dueDeligencePeriodValidText}}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Closing Period <span class="red">*</span></label>
            <div class="textbox-with-btn">
              <input class="form-control" mask="999" #closingPeriodinput="ngModel" (keydown)="onKeydown($event,'tab1')" required [(ngModel)]="offerInputModel.ClosingPeriod" (change)="closingPeriodValidation()">
              <span class="rightlabel">Days</span>
            </div>
            <p class="redtext" *ngIf="(closingPeriodValid) ||(closingPeriodinput.invalid && closingPeriodinput.touched)">{{closingPeriodValidText}}</p>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 inline-checkbox margin-bottom-20">
          <label class="form-label hidden-xs hidden-sm">&nbsp;</label>
          <label class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="offerInputModel.IsOfferContingentFinancing" (keydown)="onKeydown($event,'tab1')" (change)="onOfferContingentFinancingChange($event)">
            Offer Contingent upon Financing
            <i></i>
          </label>
        </div>
      </div>
      <div class="row" *ngIf="offerInputModel.IsOfferContingentFinancing">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">LTV Ratio</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" [dropSpecialCharacters]="false" mask="99.99" (keydown)="onKeydown($event,'tab1')" (change)="validationService.onlyDecimal($event);" [(ngModel)]="offerInputModel.LTV" />
              <span class="rightlabel">%</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Interest Rate</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" [dropSpecialCharacters]="false" mask="99.99" (keydown)="onKeydown($event,'tab1')" (change)="validationService.onlyDecimal($event);" [(ngModel)]="offerInputModel.InterestRate" />
              <span class="rightlabel">%</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Term</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" mask="999" (keydown)="onKeydown($event,'tab1')" [(ngModel)]="offerInputModel.Term" />
              <span class="rightlabel">Years</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Amortization</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" mask="999" (keydown)="onKeydown($event,'tab1')" [(ngModel)]="offerInputModel.Amortization" />
              <span class="rightlabel">Years</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 inline-checkbox margin-bottom-20">
          <label class="form-label hidden-xs hidden-sm">&nbsp;</label>
          <label class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="offerInputModel.HaveOtherNNNasset" (keydown)="onKeydown($event,'tab1')">
            Do you own other NNN assets?
            <i></i>
          </label>

        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group">
            <label class="form-label">Any other comments to supplement your offer?</label>
            <textarea class="form-control" maxlength="999" [(ngModel)]="offerInputModel.Comments"></textarea>
          </div>
        </div>
      </div>

      <div *ngIf="isEdit || isFromQuickEdit">
        <div class="floatinghead clearfix">
          <h3 class="bluelabel margin-bottom-15">PREVIOUS UPLOADED LOI</h3>
        </div>

        <div class="table-responsive margin-bottom-20 margin-top-15">
          <table class="table basictable">
            <thead>
              <tr>
                <th style="width:50px">#</th>
                <th>Document Title</th>
                <th>Category</th>
                <th>Action</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of offerInputModel.Documents; let i = index;">

                <td>
                  <p>{{i + 1}}</p>
                </td>
                <td>
                  <p>{{doc.Name}}</p>
                </td>
                <td>
                  <p>{{doc.Category}}</p>
                </td>
                <td>
                  <a *ngIf="doc.FilePath.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', doc)" placement="top">
                    <i aria-hidden="true" class="fa fa-eye"></i>
                  </a>
                  <a *ngIf="doc.FilePath != null && doc.FilePath.length > 0" class="view" href={{doc.FilePath}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                     ng-reflect-placement="top" triggers="hover">
                    <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                  </a>
                </td>

              </tr>
              <tr *ngIf="offerInputModel.Documents?.length === 0">
                <td colspan="6" style="text-align: center; font-weight: normal; color: gray">

                  <div class="nodata">
                    <i class="icofont icofont-warning icon"></i>
                    <p>No Documents Added</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="floatinghead clearfix">
        <h3 class="bluelabel margin-bottom-15">ADDITIONAL INFORMATION</h3>
      </div>

      <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) [uploadType]="fileUploadType" [fileDocExt]="'pdf,xlsx,doc,docx,xls,txt,dwg'" [extensionType]="fileExtensionType" [showList]="false" [clearFilescounter]="clearFiles" [fileTypes]="allFileTypes"></file-upload>



      <label class="alert-danger">{{errorMessageForLOI}}</label>
      <div class="table-responsive">
        <table class="table basictable fixedlayouttable" *ngIf="filesCollection.length > 0">
          <thead>
            <tr>
              <th class="minwidth40">File</th>
              <th class="minwidth40">Category</th>
              <th class="minwidth20">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of filesCollection;let i = index" [attr.data-index]="i">
              <td><p>{{file.name}}</p></td>
              <td>
                <label>

                  <label>Additional Documents</label>
                  <i></i>

                </label>
              </td>
              <td>
                <a class="remove" href="javascript:void(0);" (click)="onRemoveDocument(i)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <div class="btnspace margin-top-20 clearfix">
        <div class="left" [hidden]="isFromQuickEdit">
          <button class="btn btn-border btn-lg margin-bottom-15 margin-right-10" [disabled]="isSaveDisabled" (click)="savePlaceOffer(templateSuccess,'',true,0)">Save as draft</button>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-default btn-lg margin-bottom-15 margin-right-10" (click)="openModal(template,'','',false,true)">Cancel</button>
          <button class="btn btn-success btn-lg margin-bottom-15" (click)="showWizard(3)">Generate LOI <i class="fa fa-angle-right" aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
    <div class="margin-bottom-0" [ngClass]="{'show':wizard == 1,'hide':wizard != 1}" style="margin: 15px;">
      <div class="row  margin-bottom-20" *ngIf="!isNormalPrincipalView && !IsExternalBroker || showPortfolio">
        <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12 inline-checkbox" *ngIf="showLinkto1031Exchange">
          <label class="custom-checkbox">
            <input type="checkbox" [disabled]="isEdit || isFromQuickEdit" [(ngModel)]="offerInputModel.Is1031Exchange" (keydown)="onKeydown($event,'tab1')" (change)="onIs1031ExchangeCheckboxChange(offerInputModel.Is1031Exchange)">
            Link to B+E 1031 Exchange <span style="font:italic;margin-left:10px;color:red"> Note : Exchange once set cannot be modified.</span>
            <i></i>
          </label>
        </div>
        <div *ngIf="(isBrokerView || authService.Admin()||authService.SuperAdmin())" class="col-lg-4 col-md-4 col-sm-6 col-xs-12 inline-checkbox" style="text-align:right !important">
          <button type="button" *ngIf="selectExchange == 'Change Exchange'" class="btn btn-default btn-lg margin-right-10" (click)="ClearExchange()" style="font-size:14px;">Clear</button>
          <button *ngIf="offerInputModel.Is1031Exchange && !isEdit && !isFromQuickEdit" class="btn-border btn adduserbtn" (click)="openBrokerModal(templateBrokers,'panlestyle')">{{selectExchange}}</button>
        </div>

      </div>

      <div class="row" *ngIf="!isNormalPrincipalView && !IsExternalBroker && propType == 601 && (isBrokerView ||  authService.Admin()||authService.SuperAdmin())">
        <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12 inline-checkbox margin-bottom-20">
          <label class="custom-checkbox">
            <input type="checkbox" [disabled]="isEdit || isFromQuickEdit" [(ngModel)]="offerInputModel.OfferForExtBroker" (change)="onExternalBrokerPlaceOffer()">
            Place offer on behalf of Co-Broker
            <i></i>
          </label>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 inline-checkbox" *ngIf="offerInputModel.OfferForExtBroker && !isEdit && !isFromQuickEdit" style="text-align:right !important">
          <button type="button" *ngIf="brokerSelectedFromSlider" class="btn btn-default btn-lg margin-bottom-15 margin-right-10 margin-top-20" (click)="clearBrokerSelectedFromSlider();">Clear</button>
          <button class="btn-border btn adduserbtn" (click)="openBrokerModal(templateExtBroker,'panlestyle')">{{selectBroker}}</button>
        </div>
      </div>

      <div class="row" *ngIf="offerInputModel.Is1031Exchange && !isNormalPrincipalView">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="exchangeCodes?.length > 0">
          <div class="form-group">
            <label class="form-label">1031 Exchanges</label>
            <label class="select breadcumbarea-select bigselect">
              <div class="information" *ngIf="IsConnectedExchange" tooltip="Connected Exchange" placement="left"><span class="fa fa-info"></span></div>
              <select class="form-control" [(ngModel)]="offerInputModel.Exchange1031Id" (change)="on1031ExchangeChange($event)" (keydown)="onKeydown($event,'tab1')">

                <option *ngFor="let item of exchangeCodes" [(ngValue)]="item.Id">{{item.ExchangeCode}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
      </div>

      <div class="row  margin-bottom-20">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 inline-checkbox" *ngIf="(authService.Broker()|| authService.Admin()||authService.SuperAdmin()) && (((offerInputModel.CoBrokerId == 0||offerInputModel.CoBrokerId==null)&&(offerInputModel.OfferForExtBroker == false||offerInputModel.OfferForExtBroker==null)) || (offerInputModel.CoBrokerId > 0 && (offerInputModel.OfferForExtBroker == false||offerInputModel.OfferForExtBroker==null)))">
          <label class="custom-checkbox">
            <input type="checkbox" [(ngModel)]="offerInputModel.IsSendMail">
            Send Notification
            <i></i>
          </label>
        </div>

      </div>

      <div class="floatinghead clearfix" *ngIf="!offerInputModel.OfferForExtBroker || showBuyerInfoForPrincipal">
        <h2 class="mainhead "><span class="text">Buyer Information</span><!--<i tooltip="Buyer Information" class="fa fa-info-circle infoicon" aria-hidden="true"></i>--></h2>
      </div>
      <div *ngIf="showBuyerInfoForPrincipal">

        <div class="row">

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">First Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event,'tab2')" disabled #firstNameinput="ngModel" required [(ngModel)]="offerInputModel.FirstName" maxlength="100">
              <p class="redtext" *ngIf="(firstNameValid && firstNameinput.invalid && firstNameinput.touched)">First name is required </p>

            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.LastName" (keydown)="onKeydown($event,'tab2')" maxlength="100">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span class="red">*</span></label>
              <input class="form-control" disabled #emailinput="ngModel" (keydown)="onKeydown($event,'tab2')" (change)="validateEmail()" autocomplete="off" maxlength="100" required [(ngModel)]="offerInputModel.Email">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" disabled #phoneNumberinput="ngModel" (keydown)="onKeydown($event,'tab2')" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20">
              <p class="redtext" *ngIf="(phoneValid) && phoneNumberinput.invalid && phoneNumberinput.touched">Phone number is required</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.CompanyName" (keydown)="onKeydown($event,'tab2')" maxlength="200">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Buyer Entity</label>
              <input class="form-control" (keydown)="onKeydown($event,'tab2')" [(ngModel)]="offerInputModel.BuyerEntity" maxlength="200">
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(isBrokerView || authService.Admin()||authService.SuperAdmin()) && !offerInputModel.OfferForExtBroker">
        <div class="row" *ngIf="disableTextBox === 'true'">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="offerInputModel.Exchange1031Id>0">
            <div class="form-group">
              <label class="form-label">Exchange ID</label>
              <input class="form-control" [(ngModel)]="offerInputModel.Exchange1031Id" [disabled]="true">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group autocomplete-design">
              <label class="form-label">
                First Name<span class="star">*</span>
              </label>

              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #firstNameinput="ngModel" [(ngModel)]="offerInputModel.FirstName" required maxlength="100" [disabled]="true" onKeydown>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #lastNameinput="ngModel" [(ngModel)]="offerInputModel.LastName" required maxlength="100" [disabled]="true">
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [disabled]="true" [(ngModel)]="offerInputModel.Email">
            </div>
          </div>



          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #phoneNumberinput="ngModel" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' id="txtPhone" maxlength="20" [disabled]="true">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="disableTextBox === 'true'">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" [(ngModel)]="offerInputModel.CompanyName" maxlength="200" [disabled]="true">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Buyer Entity</label>
              <input class="form-control" [(ngModel)]="offerInputModel.BuyerEntity" maxlength="200">
            </div>
          </div>
        </div>

        <!--If Exchange is selected-->
        <!--If Exchange is not selected-->
        <div class="row" *ngIf="disableTextBox === 'false' && !IsExternalBroker">
          <div class="cf">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="offerInputModel.Exchange1031Id>0">
              <div class="form-group">
                <label class="form-label">Exchange ID</label>
                <input class="form-control" [disabled]="isExchangeDisabled" [(ngModel)]="offerInputModel.Exchange1031Id">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Email<span class="red">*</span></label>
                <input class="form-control" [disabled]="isExchangeDisabled || isEdit || isFromQuickEdit" (keydown)="onBuyerInfoKeydown();" (change)="checkDuplicateUser()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [(ngModel)]="offerInputModel.Email">

                <p class="redtext" *ngIf="((emailValid) || emailinput.invalid && emailinput.touched) && emailvalidation=='' ">Email is required</p>

                <p class="redtext" *ngIf="(emailvalidation!='' && offerInputModel.Email!='' )">{{emailvalidation}}</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group autocomplete-design">
                <label class="form-label">
                  First Name<span class="star">*</span>
                </label>

                <input class="form-control" [disabled]="isExchangeDisabled || isEdit || isFromQuickEdit" (keydown)="onBuyerInfoKeydown()" #firstNameinput="ngModel" [(ngModel)]="offerInputModel.FirstName" required maxlength="100">
                <p class="redtext" *ngIf="(firstNameValid)||(firstNameinput.invalid && firstNameinput.touched)">First Name is required</p>
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Last Name<span class="red">*</span></label>
                <input class="form-control" [disabled]="isExchangeDisabled || isEdit || isFromQuickEdit" (keydown)="onBuyerInfoKeydown()" #lastNameinput="ngModel" [(ngModel)]="offerInputModel.LastName" required maxlength="100">
                <p class="redtext" *ngIf="(lastNameValid) || (lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
              </div>
            </div>


            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Phone<span class="red">*</span></label>
                <input class="form-control" [disabled]="isExchangeDisabled || isEdit || isFromQuickEdit" (keydown)="onBuyerInfoKeydown()" #phoneNumberinput="ngModel" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhone">
                <p class="redtext" *ngIf="((phoneValid) || (phoneNumberinput.invalid && phoneNumberinput.touched) )&& phoneValidation =='' ">Phone number is required</p>
                <p class="redtext" *ngIf="(phoneValidation!='' && offerInputModel.Phone !='')">{{phoneValidation}}</p>
              </div>
            </div>
          </div>
          <div class="cf">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="disableTextBox === 'false' && !IsExternalBroker">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="form-label">Company Name</label>
                    <input class="form-control" [disabled]="isExchangeDisabled || isEdit || isFromQuickEdit" [(ngModel)]="offerInputModel.CompanyName" maxlength="200">
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="form-label">Buyer Entity</label>
                    <input class="form-control" [disabled]="isExchangeDisabled || isEdit || isFromQuickEdit" [(ngModel)]="offerInputModel.BuyerEntity" maxlength="200">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="disableTextBox === 'false' && IsExternalBroker">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="offerInputModel.Exchange1031Id>0">
            <div class="form-group">
              <label class="form-label">Exchange ID</label>
              <input class="form-control" disabled [(ngModel)]="offerInputModel.Exchange1031Id">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group autocomplete-design">
              <label class="form-label">
                First Name<span class="star">*</span>
              </label>

              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #firstNameinput="ngModel" [(ngModel)]="offerInputModel.FirstName" required maxlength="100" [disabled]="isEdit">
              <p class="redtext" *ngIf="(firstNameValid)||(firstNameinput.invalid && firstNameinput.touched)">First Name is required</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #lastNameinput="ngModel" [(ngModel)]="offerInputModel.LastName" required maxlength="100" [disabled]="isEdit">
              <p class="redtext" *ngIf="(lastNameValid) || (lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email</label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [disabled]="isEdit" [(ngModel)]="offerInputModel.Email">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone</label>
              <input class="form-control" (keydown)="onBuyerInfoKeydown()" #phoneNumberinput="ngModel" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhone" [disabled]="isEdit">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="disableTextBox === 'false' && IsExternalBroker">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" [(ngModel)]="offerInputModel.CompanyName" maxlength="200">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Buyer Entity</label>
              <input class="form-control" [(ngModel)]="offerInputModel.BuyerEntity" maxlength="200">
            </div>
          </div>
        </div>
        <!--If Exchange is not selected-->
        <div [hidden]="true">
          <h2 class="mainhead "><span class="text">Co-Broker Information</span></h2>
          <div class="row">

            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">First Name</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerFirstName">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Last Name</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerLastName">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Email</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerEmail">
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Phone</label>
                <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerPhone" mask='(000) 000-0000'>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Broker view when placing offer on behalf of external broker start-->
      <ng-container *ngTemplateOutlet="BrokerForEB"></ng-container>
      <!--Broker view when placing offer on behalf of external broker end-->

      <h2 class="mainhead "><span class="text">Offer Details</span></h2>
      <div class="row">

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Asking Price </label>
            <div class="textbox-with-btn-left" *ngIf="!showPortfolio && !propertyDetailForOffer.Unpriced">
              <input disabled class="form-control" value="{{propertyDetailForOffer.Price|number}}" />
              <span class="leftlabel">$</span>
            </div>
            <div class="textbox-with-btn-left" *ngIf="showPortfolio && !propertyDetailForOffer.Unpriced">
              <input disabled class="form-control" value="{{askingPrice|number}}" />
              <span class="leftlabel">$</span>
            </div>

            <div class="textbox-with-btn" *ngIf="!showPortfolio && propertyDetailForOffer.Unpriced">
              <input disabled class="form-control" value="Unpriced" />
            </div>
            <div class="textbox-with-btn" *ngIf="showPortfolio && propertyDetailForOffer.Unpriced">
              <input disabled class="form-control" value="Unpriced" />
            </div>

          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Offer Price <span class="red">*</span></label>
            <div class="textbox-with-btn-left">
              <input type="text" inputmode="numeric" class="form-control" (keydown)="onKeydown($event,'tab1')" mask="separator.10" thousandSeparator="," maxlength="18" (change)="offerPriceValidation()" required [(ngModel)]="offerInputModel.OfferPrice" #offerpriceinput="ngModel">
              <span class="leftlabel">$</span>
            </div>

            <p class="redtext" *ngIf="(offerPriceValid)||(offerpriceinput.invalid && offerpriceinput.touched)">{{offerPriceValidText}}</p>

          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Earnest Money Deposit <span class="red">*</span></label>
            <div class="textbox-with-btn-left">
              <input class="form-control" type="text" inputmode="numeric" mask="separator.10" thousandSeparator="," maxlength="18" (keydown)="onKeydown($event,'tab1')" (change)="earnestMoneyDepositValidation()" #earnestMoneyDepositinput="ngModel" required [(ngModel)]="offerInputModel.EarnestMoneyDeposit">
              <span class="leftlabel">$</span>
            </div>
            <p class="redtext" *ngIf="(earnestMoneyDepositValid) ||(earnestMoneyDepositinput.invalid && earnestMoneyDepositinput.touched)">{{earnestMoneyDepositValidText}}</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Due Diligence Period<span class="red">*</span></label>
            <div class="textbox-with-btn">
              <input class="form-control" mask="999" #dueDiligencePeriodinput="ngModel" (keydown)="onKeydown($event,'tab1')" required (change)="dueDiligencePeriodValidation()" [(ngModel)]="offerInputModel.DueDiligencePeriod">
              <span class="rightlabel">Days</span>
            </div>
            <p class="redtext" *ngIf="(dueDiligencePeriodValid) ||(dueDiligencePeriodinput.invalid && dueDiligencePeriodinput.touched)">{{dueDeligencePeriodValidText}}</p>
          </div>
        </div>


      </div>
      <div class="row">

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Closing Period <span class="red">*</span></label>
            <div class="textbox-with-btn">
              <input class="form-control" mask="999" #closingPeriodinput="ngModel" (keydown)="onKeydown($event,'tab1')" required [(ngModel)]="offerInputModel.ClosingPeriod" (change)="closingPeriodValidation()">
              <span class="rightlabel">Days</span>
            </div>
            <p class="redtext" *ngIf="(closingPeriodValid) ||(closingPeriodinput.invalid && closingPeriodinput.touched)">{{closingPeriodValidText}}</p>
          </div>
        </div>

      </div>

      <div class="row" *ngIf="offerInputModel.IsOfferContingentFinancing">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">LTV Ratio</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" [dropSpecialCharacters]="false" mask="99.99" (keydown)="onKeydown($event,'tab1')" (change)="validationService.onlyDecimal($event);" [(ngModel)]="offerInputModel.LTV" />
              <span class="rightlabel">%</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Interest Rate</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" [dropSpecialCharacters]="false" mask="99.99" (keydown)="onKeydown($event,'tab1')" (change)="validationService.onlyDecimal($event);" [(ngModel)]="offerInputModel.InterestRate" />
              <span class="rightlabel">%</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Term</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" mask="999" (keydown)="onKeydown($event,'tab1')" [(ngModel)]="offerInputModel.Term" />
              <span class="rightlabel">Years</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Amortization</label>
            <div class="textbox-with-btn">
              <input type="text" class="form-control" mask="999" (keydown)="onKeydown($event,'tab1')" [(ngModel)]="offerInputModel.Amortization" />
              <span class="rightlabel">Years</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isEdit || isFromQuickEdit">
        <div class="floatinghead clearfix">
          <h3 class="bluelabel margin-bottom-15">PREVIOUS UPLOADED LOI</h3>
        </div>

        <div class="table-responsive margin-bottom-20 margin-top-15">
          <table class="table basictable">
            <thead>
              <tr>
                <th style="width:50px">#</th>
                <th>Document Title</th>
                <th>Category</th>
                <th>Action</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of offerInputModel.Documents; let i = index;">

                <td>
                  <p>{{i + 1}}</p>
                </td>
                <td>
                  <p>{{doc.Name}}</p>
                </td>
                <td>
                  <p>{{doc.Category}}</p>
                </td>
                <td>
                  <a *ngIf="doc.FilePath.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', doc)" placement="top">
                    <i aria-hidden="true" class="fa fa-eye"></i>
                  </a>
                  <a *ngIf="doc.FilePath != null && doc.FilePath.length > 0" class="view" href={{doc.FilePath}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                     ng-reflect-placement="top" triggers="hover">
                    <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                  </a>
                </td>

              </tr>
              <tr *ngIf="offerInputModel.Documents?.length === 0">
                <td colspan="6" style="text-align: center; font-weight: normal; color: gray">

                  <div class="nodata">
                    <i class="icofont icofont-warning icon"></i>
                    <p>No Documents Added</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="floatinghead clearfix">
        <h3 class="bluelabel margin-bottom-15">Upload my own LOI</h3>
      </div>

      <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitterForLOI($event) [maxFiles]="1" [showList]="false" [extensionType]="fileExtensionType" [extensionLOIType]="fileExtensionLOIType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>

      <label class="alert-danger">{{errorMessageForLOI}}</label>
      <div class="table-responsive uploaded-file-custom">

        <table class="table basictable fixedlayouttable" *ngIf="filesCollectionLOI.length > 0">
          <thead>
            <tr>
              <th class="minwidth40">File</th>
              <th class="minwidth40">Category</th>
              <th class="minwidth20">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of filesCollectionLOI;let i = index" [attr.data-index]="i">
              <td><p>{{file.name}}</p></td>
              <td>
                <label>
                  <label class="font600">LOI Document</label>
                  <i></i>
                </label>
              </td>
              <td>
                <a class="remove" href="javascript:void(0);" (click)="onRemoveLOIDocument(i)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <div class="floatinghead clearfix">
        <h3 class="bluelabel margin-bottom-15">Upload Additional Documents</h3>
      </div>

      <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitterAdditional($event) [maxFiles]="5" [showList]="false" [fileDocExt]="'pdf,xlsx,doc,docx,xls,txt,dwg'" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="allFileTypes"></file-upload>



      <label class="alert-danger">{{errorMessageForLOI}}</label>
      <div class="table-responsive">

        <table class="table basictable fixedlayouttable" *ngIf="filesCollectionAdditional.length > 0">
          <thead>
            <tr>
              <th class="minwidth40">File</th>
              <th class="minwidth40">Category</th>
              <th class="minwidth20">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of filesCollectionAdditional;let i = index" [attr.data-index]="i">
              <td><p>{{file.name}}</p></td>
              <td>
                <label>
                  <label>Additional Documents</label>
                </label>
              </td>
              <td>
                <a class="remove" href="javascript:void(0);" (click)="onRemoveAdditionalDocument(i)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
              </td>

            </tr>
          </tbody>
        </table>
      </div>



      <div class="row" *ngIf="!isFromQuickEdit">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group">
            <label class="form-label">Comments</label>
            <textarea class="form-control" maxlength="999" [(ngModel)]="offerInputModel.Comments"></textarea>
          </div>
        </div>
      </div>
      <div class="btnspace btn-4-sm margin-top-20 d-flex row clearfix">
        <div class="col-md-6">
          <button class="btn btn-border btn-lg margin-bottom-15 margin-right-10" [hidden]="isFromQuickEdit" [disabled]="isSaveDisabled" (click)="savePlaceOffer(templateSuccess,'',true,0)">Save as draft</button>
          <button class="btn btn-border btn-lg margin-bottom-15 margin-right-10" [hidden]="isFromQuickEdit" href="javascript:void(0);" [disabled]="isOwnLOI && filesCollectionLOI.length === 0" (click)="openModalShareWithOhters(templateShareOthers,'example1@eg.com')">Share with others</button>
        </div>
        <!-- [ngStyle]="{'width':isFromQuickEdit ? '100%' : '40%' }"-->
        <div class="col-md-6 text-right">
          <button type="button" class="btn btn-default btn-lg margin-bottom-15 margin-right-10" (click)="openModal(template,'','',false,true)">Cancel</button>
          <button class="btn btn-success btn-lg margin-bottom-15 " [disabled]="disblesubmitofferbutton" (click)="openModal(templateSubmit,'','LOI',true)">Submit Offer</button>
        </div>
      </div>

    </div>
    <div class="border-div margin-bottom-0 loi" [ngClass]="{'show':wizard == 3,'hide':wizard != 3}">


      <div class="margin-bottom-20">
        <h3>{{today | date:'MM/dd/yyyy'}}</h3>
      </div>
      <div class="margin-bottom-20">
        <h3>{{propertyDetailForOffer.PrimaryContactName!=null?propertyDetailForOffer.PrimaryContactName:'(N/A)'}}</h3>
        <h3>B + E</h3>
        <h3>{{propertyDetailForOffer.PrimaryContactPhone!=null?(propertyDetailForOffer.PrimaryContactPhone | phone):'(N/A)'}}</h3>
        <h3>{{propertyDetailForOffer.PrimaryContactEmail!=null?propertyDetailForOffer.PrimaryContactEmail:'(N/A)'}}</h3>
      </div>
      <div class="margin-bottom-20">
        <h3>Letter of Intent to Purchase <b>{{propertyDetailForOffer.PropertyName}}</b></h3>
      </div>
      <p class="margin-bottom-20">
        {{offerInputModel.FirstName}} {{offerInputModel.LastName}} and or assigns presents this non-binding Letter of Intent (“LOI”) to Seller to establish the basic
        terms to be used in the negotiation of a Purchase and Sale Agreement (“PSA”) for the Property detailed
        below:
      </p>

      <h5><u><b>Property</b></u></h5>
      <p *ngIf="haveaccesstoviewlocation">{{propertyDetailForOffer.PropertyAddress}} leased to {{propertyDetailForOffer.TenantName}}</p>
      <p *ngIf="!haveaccesstoviewlocation">Confidential Location leased to {{propertyDetailForOffer.TenantName}}</p>

      <h5><u><b>Purchase Price </b></u></h5>
      <p class="capitalizeletter">
        {{ offerInputModel.OfferPriceToWords }} dollars
        ({{ offerInputModel.OfferPrice !== 0 ? ('$ ' + (offerInputModel.OfferPrice | number: '1.0-0')) : '-' }})
      </p>

      <h5><u><b>Deposit</b></u></h5>
      <p>
        Buyer will place {{offerInputModel.EarnestMoneyDepositToWords}} dollars ({{offerInputModel.EarnestMoneyDeposit!=0?('$ '+ (offerInputModel.EarnestMoneyDeposit|number : '1.0-0')):'-'}}) with a mutually acceptable escrow agent upon the
        execution of the PSA. The Deposit will be fully refundable If the Buyer terminates the PSA prior to the
        expiration of the Due Diligence Period.
      </p>

      <h5><u><b>Due Diligence Period</b></u></h5>
      <p>
        Buyer will have {{offerInputModel.DueDiligencePeriodToWords}} ({{offerInputModel.DueDiligencePeriod}}) days from the execution of the PSA to conduct its due diligence with the
        respect to the acquisition of the Property.
      </p>

      <h5><u><b>Financing Contingency</b></u></h5>
      <p *ngIf="!offerInputModel.IsOfferContingentFinancing">None</p>
      <p *ngIf="offerInputModel.IsOfferContingentFinancing">
        Closing of Title is contingent on the Buyer’s ability to obtain financing of with a {{offerInputModel.LTV}}% loan-to-
        value ratio, {{offerInputModel.InterestRate}}% interest rate, {{offerInputModel.Term}} year term, and {{offerInputModel.Amortization}} year amortization.
      </p>

      <h5><u><b>Closing</b></u></h5>
      <p>The closing of title shall be within {{offerInputModel.ClosingPeriodToWords}} ({{offerInputModel.ClosingPeriod}}) days after the expiration of the Due Diligence Period.</p>

      <h5><u><b>Title</b></u></h5>
      <p>
        Seller shall convey to Buyer good and marketable title to the Property, subject only to such encumbrances,
        easements, rights of way and other exceptions to title as shall be acceptable to Buyer in its sole discretion.
      </p>

      <h5><u><b>1031 Exchange</b></u></h5>
      <p *ngIf="offerInputModel.Is1031Exchange">
        Seller and Buyer agree to cooperate should either party elect to sell or purchase the Property
        under the provision of an Internal Revenue Code Section 1031 tax deferred exchange.
      </p>
      <p *ngIf="!offerInputModel.Is1031Exchange">
        None
      </p>

      <h5><u><b>Tenant Estoppel/SNDA</b></u></h5>
      <p>Prior to Closing, Seller will provide Buyer executed Estoppel and SNDA letters from Tenant.</p>

      <h5><u><b>Cost and Fees</b></u></h5>
      <p>Closing costs to be handled per local custom.</p>

      <br />
      <h4><b>Agreed and Accepted</b></h4>
      <br />
      <table style="width: 100%;">
        <tbody>
          <tr>
            <td style="vertical-align:top">
              <p style="font-style:italic">{{offerInputModel.FirstName}} {{offerInputModel.LastName}}</p>
              <div class="blank-line"></div>
              <p>Buyer Name: {{offerInputModel.FirstName}} {{offerInputModel.LastName}} {{getBuyerNameIfAny()}}</p>
              <p>Date: {{today | date:'MM/dd/yyyy'}}</p>
            </td>
            <td style="vertical-align:top">
              <p></p>
              <div class="blank-line"></div>
              <p>Seller Name</p>
              <p>Date</p>
            </td>
          </tr>
        </tbody>
      </table>

      <h6 class="displayvalue">The content of the LOI shall be confidential in nature and shall not be disclosed to other buyers.</h6>

      <div class="btnspace margin-top-20 clearfix">
        <div class="left" [hidden]="isFromQuickEdit">
          <button class="btn btn-border btn-lg margin-bottom-15 margin-right-10" [disabled]="isSaveDisabled" (click)="savePlaceOffer(templateSuccess,'',true,0)">Save as draft</button>
          <button class="btn btn-border btn-lg margin-bottom-15 margin-right-10" href="javascript:void(0);" [disabled]="isOwnLOI && filesCollectionLOI.length === 0" (click)="openModalShareWithOhters(templateShareOthers,'example1@eg.com')">Share with others</button>
          <a class="btn btn-border btn-lg margin-bottom-15" href="javascript:void(0);" (click)="downloadLOITemplateToPDF()">Download PDF</a>
        </div>
        <div class="text-right right" [ngStyle]="{'width':isFromQuickEdit ? '100%' : '40%' }">
          <button type="button" class="btn btn-default btn-lg margin-bottom-15 margin-right-10" (click)="openModal(template,'','', false, true)">Cancel</button>
          <button type="button" class="btn btn-blue btn-lg margin-bottom-15 " (click)="showWizard(11)">Modify</button>
          <button class="btn btn-success btn-lg margin-bottom-15 " (click)="openModal(templateSubmit,'','', true)">Submit LOI</button>
        </div>
      </div>

    </div>
    <div class="border-div successstep margin-bottom-0" [ngClass]="{'show':wizard == 4,'hide':wizard != 4}">
      <div class="tick"><span class="icon-tick2 icon"></span></div>
      <h4>Offer submitted successfully!</h4>
      <h6>{{submitLOIConfirmationMessage}}</h6>
      <div class="text-right margin-top-20">
        <a class="btn btn-default btn-lg" href="{{resultOutputModel.DocumentPath}}" target="_blank" download>Download Submitted LOI</a>
        <button class="btn btn-success btn-lg " (click)="afterSubmit()">Continue</button>
      </div>
    </div>
  </div>
</div>


<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Exit</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to cancel ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide();CancelPlaceOfferPopup()">No</button>
      <a href="javascript:void(0);" class="btn btn-lg btn-success" (click)="afterSubmit()">Yes</a>
    </div>
  </div>

</ng-template>

<ng-template #templateSubmit>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Submit LOI</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to submit this LOI?</h6>
    </div>
    <div class="form-group" *ngIf="!duplicateUserFound && !isEdit && !isFromQuickEdit">
      <label class="custom-checkbox">
        <input type="checkbox" [(ngModel)]="offerInputModel.SendInvitationMail">
        <span class="displayvalue">Send User invitation Mail</span>
        <i></i>
      </label>
    </div>
    <div class="form-group" *ngIf="isEdit">
      <p style="font-size: 12px;text-align: left;">Note: Updating Due Diligence period or closing period will update the deal timeline.</p>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide();CancelPlaceOfferPopup()">No</button>
      <button class="btn btn-lg btn-success" [disabled]="isSaveDisabled" (click)="savePlaceOffer(templateSuccess,'',false,0);modalRef.hide();">Yes</button>
    </div>
  </div>

</ng-template>

<ng-template #templateSuccess>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Offer submitted successfully!</h4>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Our Broker will get in touch with you soon</h6>
    </div>
    <div class="text-right">
      <a class="btn btn-success btn-lg " href="javascript:void(0);" (click)="afterSubmit()">Ok</a>
    </div>
  </div>
  <br />
</ng-template>
<br />
<ng-template #templateShareOthers class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Share LOI with Others</h4>
    <button aria-label="Close" class="close pull-right" (click)="modalRefShareWithOthers.hide()" type="button">
      <span aria-hidden="true">×</span>
    </button>
    <div class="clearfix"></div>
  </div>
  <div class="modal-body paddingformodal">
    <tag-input [(ngModel)]="mailIds" secondaryPlaceholder="Email Address" placeholder="+ Email Addresses" [errorMessages]="errorMessages" [validators]="validators" [separatorKeyCodes]="keyCode"></tag-input>
    <h5 class="infotext">
      Use a comma or space to separate multiple email addresses

    </h5>
    <div class="text-right margin-top-20">
      <button class="btn btn-default btn-lg" (click)="modalRefShareWithOthers.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" [disabled]="disabledShareBtn" (click)="shareLOIToOtherMails()">Share</button>
    </div>
  </div>
</ng-template>
<ng-template #templateBrokers class="pull-left">
  <app-offer-exchange-selector (close)="closeModal($event)" (selectedExchange)="selectedExchange($event)" [modalRef]="modalRef" [PropertyId]="propertyId"></app-offer-exchange-selector>
</ng-template>

<ng-template #templateExtBroker class="pull-left">
  <app-external-broker-selection (close)="closeModal($event)" (selectedUser)="selectedUser($event)" [modalRef]="modalRef"></app-external-broker-selection>
</ng-template>

<ng-template #MatchingUsers>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue margin-bottom-5">Broker data mismatch</h6>
    </div>
    <div class="form-group">
      <h4 class="displayvalue" style="font-size:16px">Please select the intended user from the list, and proceed to submit the offer.</h4>
    </div>
    <div class="margin-bottom-15">
      <div class="modal-data-box" *ngFor="let user of matchingUsers;let i = index" style="margin-bottom:5px;margin-right:5px;">
        <div class="row">
          <div class="col-sm-9">
            <ul class="connection-list brokerlist be-exchange-list">
              <li class="clearfix">
                <img [src]="user.ProfilePic !=='' ? user.ProfilePic  :'/../../../assets/img/default-profile-img.png'" />
                <div class="right">
                  <h6>
                    {{user.FirstName + ' '+ user.LastName}}
                  </h6>
                  <p>
                    <i class="icon-phone icon"></i> {{user.Phone|phone}}
                  </p>
                  <p>
                    <i class="icon-message icon"></i> {{user.Email}}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-sm-3">
            <p class="margin-top-10"><a href="javascript:void(0);" class="be-small-atag pull-right" (click)="onUserSelect(user)">Select</a></p>
          </div>
        </div>


      </div>

    </div>
  </div>
</ng-template>
<ng-template #BrokerForEB>
  <div *ngIf="offerInputModel.OfferForExtBroker && (authService.Broker() || authService.Admin()||authService.SuperAdmin())">
    <div *ngIf="!extBrokerSelected">
      <h2 class="mainhead ">
        <span class="text">Co-Broker Information</span>
      </h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">First Name <span class="red">*</span></label>
            <input class="form-control" (keydown)="onBuyerInfoKeydown()" #firstNameinput="ngModel" [(ngModel)]="offerInputModel.FirstName" required maxlength="100">
            <p class="redtext" *ngIf="(firstNameValid) || firstNameinput.invalid && firstNameinput.touched">First Name is required</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Last Name<span class="red">*</span></label>
            <input class="form-control" (keydown)="onBuyerInfoKeydown()" #lastNameinput="ngModel" [(ngModel)]="offerInputModel.LastName" required maxlength="100">
            <p class="redtext" *ngIf="(lastNameValid) || (lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Email<span class="red">*</span></label>
            <input class="form-control" (keydown)="onBuyerInfoKeydown()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [(ngModel)]="offerInputModel.Email">
            <p class="redtext" *ngIf="((emailValid) || emailinput.invalid && emailinput.touched) && emailvalidation=='' ">Email is required</p>
            <p class="redtext" *ngIf="(emailvalidation!='' && offerInputModel.Email!='' )">{{emailvalidation}}</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Phone<span class="red">*</span></label>
            <input class="form-control" (keydown)="onBuyerInfoKeydown()" type="text" #phoneNumberinput="ngModel" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhoneEB">
            <p class="redtext" *ngIf="((phoneValid) || (phoneNumberinput.invalid && phoneNumberinput.touched) )&& phoneValidation =='' ">Phone number is required</p>
            <p class="redtext" *ngIf="(phoneValidation!='' && offerInputModel.Phone !='')">{{phoneValidation}}</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="extBrokerSelected">
      <h2 class="mainhead ">
        <span class="text">Co-Broker Information</span>
        <button type="button" *ngIf="extBrokerSelected && !brokerSelectedFromSlider" class="btn-border btn adduserbtn" (click)="resetExBrokerSelection()">Modify User</button>
      </h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">First Name <span class="red">*</span></label>
            <input class="form-control" disabled #firstNameinput="ngModel" [(ngModel)]="offerInputModel.FirstName" required maxlength="100">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Last Name<span class="red">*</span></label>
            <input class="form-control" disabled #lastNameinput="ngModel" [(ngModel)]="offerInputModel.LastName" required maxlength="100">
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Email<span class="red">*</span></label>
            <input class="form-control" disabled #emailinput="ngModel" autocomplete="off" maxlength="100" required [(ngModel)]="offerInputModel.Email">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Phone<span class="red">*</span></label>
            <input class="form-control" disabled type="text" #phoneNumberinput="ngModel" required [(ngModel)]="offerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhoneEB">
          </div>
        </div>
      </div>
    </div>
    <div>
      <h2 class="mainhead "><span class="text">Buyer Information</span></h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">First Name</label>
            <input class="form-control" [(ngModel)]="offerInputModel.BuyerFirstName">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Last Name</label>
            <input class="form-control" [(ngModel)]="offerInputModel.BuyerLastName">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Email</label>
            <input class="form-control" [(ngModel)]="offerInputModel.BuyerEmail">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Phone</label>
            <input class="form-control" [(ngModel)]="offerInputModel.BuyerPhone" mask='(000) 000-0000'>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Company Name</label>
            <input class="form-control" [(ngModel)]="offerInputModel.BuyerCompany" maxlength="200">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Buyer Entity</label>
            <input class="form-control" [(ngModel)]="offerInputModel.EBBuyerEntity" maxlength="200">
          </div>
        </div>
      </div>
    </div>
    <div [hidden]="true">
      <h2 class="mainhead "><span class="text">Co-Broker Information</span></h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">First Name</label>
            <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerFirstName">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Last Name</label>
            <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerLastName">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Email</label>
            <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerEmail">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Phone</label>
            <input class="form-control" disabled [(ngModel)]="offerInputModel.CoBrokerPhone" mask='(000) 000-0000'>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #duplicateNameCheck>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Warning</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">{{message}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="goNext()">Proceed</button>
    </div>
  </div>

</ng-template>

<ng-template #preview>
  <div class="modal-header">
    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.FilePath" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>

  <!--<pdf-viewer [external-link-target]="'blank'" [show-all]="true" [show-borders]="true" [original-size]="true" [src]="docPreview.Url"
              [render-text]="true"
              style="display: block;"></pdf-viewer>-->
</ng-template>
<button id="BuyerQuestinnaire" [hidden]="true" (click)="openBuyerModal(BuyerQuestinnaire,'commonmodal modal-buyer-questionnaire')"></button>
<ng-template #BuyerQuestinnaire>
  <app-Buyer-Questionnaire [modalBuyerRef]="modalBuyerRef" [OfferId]="BuyerQuestionsOfferId" [PropertyId]="BuyerQuestionsPropertyId" [source]="'PlaceOffer'" [submitLOIConfirmationMessage]="submitLOIConfirmationMessage" [PropertyGuid]="propertyGuid"></app-Buyer-Questionnaire>
</ng-template>
<ng-template #sendPrincipleEmail>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Send Notification</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Would you like to notify principal?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="savePlaceOffer(templateSuccess,'',false,1);modalRefSendEmail.hide()">No</button>
      <button class="btn btn-success btn-lg" (click)="savePlaceOffer(templateSuccess,'',false,2);modalRefSendEmail.hide();">Yes</button>
    </div>
  </div>
</ng-template>
